// frontend/src/components/production-sequence/RecalcBadge.tsx
import { useTranslation } from 'react-i18next';

interface Props { dark: boolean; onReset: () => void; }

export function RecalcBadge({ dark, onReset }: Props) {
  const { t } = useTranslation();
  return (
    <div className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-lg text-[11px] font-semibold ${
      dark ? 'bg-amber-950/40 text-amber-400 border border-amber-500/30'
           : 'bg-amber-50 text-amber-700 border border-amber-200'
    }`}>
      <svg className="w-3.5 h-3.5 shrink-0" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 1.5L15 14H1L8 1.5z" /><path d="M8 6.5v3.5M8 11.8v.2" />
      </svg>
      <span>{t('sequence.customViewBadge')}</span>
      <button
        onClick={onReset}
        className={`underline underline-offset-2 cursor-pointer ${dark ? 'hover:text-amber-200' : 'hover:text-amber-900'}`}
      >
        {t('sequence.resetOrder')}
      </button>
    </div>
  );
}
